<stripe-setup *ngIf="billingFlow === BillingFlow.STRIPE_SETUP"></stripe-setup>

<contact-admin
	*ngIf="billingFlow === BillingFlow.CONTACT_ADMIN"
></contact-admin>
